import { useState } from 'react';
import { plural, t } from '@lingui/core/macro';
import { Box, AvatarWithLabel, Button, ButtonGroup, IconButton, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SelectProjectsMenu } from 'app/domains/projects';
import { AclAction } from 'shared/domains/apollo/generated/types';
export function Projects(props) {
    const { projects, disabled, onChangeProjects } = props;
    const [accessLevel, setAccessLevel] = useState([AclAction.Read]);
    const accessLevels = [
        {
            label: t({
                message: 'Viewer',
                comment: 'Bulk upload: Project access level',
            }),
            value: [AclAction.Read],
            description: t({
                message: 'Can view the project',
                comment: 'Bulk upload: Project access level description',
            }),
            icon: <Falcon icon="eye"/>,
        },
        {
            label: t({
                message: 'Editor',
                comment: 'Bulk upload: Project access level',
            }),
            value: [AclAction.Read, AclAction.Write, AclAction.Delete],
            description: t({
                message: 'Can view and edit the project',
                comment: 'Bulk upload: Project access level description',
            }),
            icon: <Falcon icon="pen"/>,
        },
    ];
    const activeAccessLevel = accessLevels.find((level) => level.value.join(',') === accessLevel.join(','));
    const handleSetAccessLevel = (level) => {
        setAccessLevel(level);
        onChangeProjects(projects.map((p) => (Object.assign(Object.assign({}, p), { aclActions: level }))));
    };
    const handleSelectProject = (project) => {
        const newProjectData = [...projects, project].map((p) => (Object.assign(Object.assign({}, p), { aclActions: accessLevel })));
        onChangeProjects(newProjectData);
    };
    const handleDeselectProject = (projectId) => {
        onChangeProjects(projects.filter((p) => p.id !== projectId));
    };
    const deselectAllProjects = () => {
        onChangeProjects([]);
    };
    const projectCount = projects.length;
    const getSelectedProjectsText = () => {
        if (projects.length === 0) {
            return t({
                message: 'Add',
                comment: 'Upload documents dialog settings - Projects no projects selected',
            });
        }
        if (projects.length === 1) {
            return projects[0].name;
        }
        return t({
            message: plural(projects.length, {
                one: '# project',
                other: '# projects',
            }),
            comment: 'Upload documents dialog settings - Projects multiple projects selected',
        });
    };
    const handleSelect = (project) => {
        const isSelected = projects.some((p) => p.id === project.id);
        if (isSelected) {
            return handleDeselectProject(project.id);
        }
        return handleSelectProject({ id: project.id, name: project.name, aclActions: accessLevel });
    };
    const selectedProjectIds = projects.map((p) => p.id);
    return (<Box alignItems="center" justifyContent="space-between">
      <AvatarWithLabel size="sm" appearance="light" title={t({
            message: 'Projects',
            comment: 'Upload documents dialog settings - Projects label',
        })} subtitle={t({
            message: 'Optionally add your documents to a project',
            comment: 'Upload documents dialog settings - Projects description',
        })}>
        <Falcon icon="rectangle-history"/>
      </AvatarWithLabel>

      <ButtonGroup>
        <SelectProjectsMenu renderTarget={({ open, setOpen }) => (<Button disabled={disabled} type="button" appearance="secondary" size="xs" onClick={() => setOpen(!open)}>
              {getSelectedProjectsText()}
            </Button>)} selectedProjectIds={selectedProjectIds} onSelect={handleSelect}/>

        {projectCount > 0 && (<Menu.Root target={<Button type="button" disabled={disabled} appearance="secondary" size="xs">
                {activeAccessLevel === null || activeAccessLevel === void 0 ? void 0 : activeAccessLevel.label}
              </Button>}>
            {accessLevels.map((access) => (<Menu.ItemCheckbox key={access.label} onChange={() => handleSetAccessLevel(access.value)} checked={access.value.join(',') === accessLevel.join(',')}>
                {access.icon}
                <Menu.ItemText primary={access.label} secondary={access.description}/>
              </Menu.ItemCheckbox>))}
          </Menu.Root>)}

        {projectCount > 0 && (<IconButton size="xs" disabled={disabled} appearance="secondary" onClick={deselectAllProjects} aria-label={t({
                message: 'Remove all projects',
                comment: 'Bulk upload - Remove all projects',
            })}>
            <Falcon icon="xmark"/>
          </IconButton>)}
      </ButtonGroup>
    </Box>);
}
